// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbotmodal {
    width: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    
    /* Enhanced smooth transitions */
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform: translateY(0) scale(1);
    opacity: 1;
    
    /* Initial state when opening */
    animation: slideInUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Keyframe animation for opening */
@keyframes slideInUp {
    0% {
        transform: translateY(100%) scale(0.9);
        opacity: 0;
    }
    100% {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
}

/* Keyframe animation for closing */
@keyframes slideOutDown {
    0% {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
    100% {
        transform: translateY(100%) scale(0.9);
        opacity: 0;
    }
}

.closing {
    /* Apply closing animation */
    animation: slideOutDown 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform: translateY(100%) scale(0.9);
    opacity: 0;
}

.chatbox-header {
    background-color: #F37920;
    border-radius: 0.25rem 0.25rem 0 0;
}

.chatbox-header h5 {
    color: white;
}

.chatbox-header .btn-link {
    font-size: 1.5rem;
    text-decoration: none;
}

.chatbox-body {
    flex-grow: 1;
    overflow-y: auto;
    padding: 1rem;
    height: 280px;
}

.message {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.message.user {
    flex-direction: row-reverse;
}

.message.other {
    flex-direction: row;
}

.message-text {
    background-color: #f1f1f1;
    padding: 8px;
    border-radius: 15px;
    margin-left: 10px;
    max-width: 100%;
}

.message.user .message-text {
    margin-left: 0;
    margin-right: 10px;
}

.message.other .message-text {
    margin-right: 10px;
}

.chatbotmodal .avatar {
    width: 40px;
    height: 40px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chatbotmodal .input-group-append .btn {
    border-radius: 0 0.25rem 0.25rem 0;
}

.chatbotmodal input.form-control {
    border: none;
    /* Removes the border */
    border-radius: 0;
    /* Removes any border-radius */
    outline: none;
    /* Removes the outline on focus */
    box-shadow: none;
    /* Removes any box shadow */
    padding-left: 0;
    /* Adjust padding to align text */
    background-color: transparent;
    /* Makes the background transparent */
}

.chatbotmodal input.form-control::placeholder {
    color: #6c757d;
    font-style: italic;
}

.chatbotmodal input.form-control:focus {
    border: none;
    outline: none;
    box-shadow: none;
}

.messenger-icon {
    width: 50px;
    height: 50px;
    cursor: pointer;
    font-size: 1.5rem;
    transition: transform 0.3s ease-in-out;
}

.messenger-icon:hover {
    transform: scale(1.1);
}

.chat-size {
    font-size: 8px;
}

.chat-close-button{
    font-size: 2rem !important;
    width: 2em;
}

.notification-dot {
    position: absolute;
    top: 0;
    left: 0;
    width: 12px;
    height: 12px;
    background-color: red;
    border-radius: 50%;
    border: 2px solid white; /* Optional border to make it stand out */
}`, "",{"version":3,"sources":["webpack://./src/components/common/ChatPopup.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;;IAEV,gCAAgC;IAChC,qDAAqD;IACrD,iCAAiC;IACjC,UAAU;;IAEV,+BAA+B;IAC/B,0DAA0D;AAC9D;;AAEA,mCAAmC;AACnC;IACI;QACI,sCAAsC;QACtC,UAAU;IACd;IACA;QACI,iCAAiC;QACjC,UAAU;IACd;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,iCAAiC;QACjC,UAAU;IACd;IACA;QACI,sCAAsC;QACtC,UAAU;IACd;AACJ;;AAEA;IACI,4BAA4B;IAC5B,6DAA6D;IAC7D,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,iCAAiC;IACjC,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB,EAAE,yCAAyC;AACtE","sourcesContent":[".chatbotmodal {\n    width: 380px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    z-index: 1;\n    \n    /* Enhanced smooth transitions */\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform: translateY(0) scale(1);\n    opacity: 1;\n    \n    /* Initial state when opening */\n    animation: slideInUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n/* Keyframe animation for opening */\n@keyframes slideInUp {\n    0% {\n        transform: translateY(100%) scale(0.9);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0) scale(1);\n        opacity: 1;\n    }\n}\n\n/* Keyframe animation for closing */\n@keyframes slideOutDown {\n    0% {\n        transform: translateY(0) scale(1);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100%) scale(0.9);\n        opacity: 0;\n    }\n}\n\n.closing {\n    /* Apply closing animation */\n    animation: slideOutDown 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform: translateY(100%) scale(0.9);\n    opacity: 0;\n}\n\n.chatbox-header {\n    background-color: #F37920;\n    border-radius: 0.25rem 0.25rem 0 0;\n}\n\n.chatbox-header h5 {\n    color: white;\n}\n\n.chatbox-header .btn-link {\n    font-size: 1.5rem;\n    text-decoration: none;\n}\n\n.chatbox-body {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 1rem;\n    height: 280px;\n}\n\n.message {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.message.user {\n    flex-direction: row-reverse;\n}\n\n.message.other {\n    flex-direction: row;\n}\n\n.message-text {\n    background-color: #f1f1f1;\n    padding: 8px;\n    border-radius: 15px;\n    margin-left: 10px;\n    max-width: 100%;\n}\n\n.message.user .message-text {\n    margin-left: 0;\n    margin-right: 10px;\n}\n\n.message.other .message-text {\n    margin-right: 10px;\n}\n\n.chatbotmodal .avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.chatbotmodal .input-group-append .btn {\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.chatbotmodal input.form-control {\n    border: none;\n    /* Removes the border */\n    border-radius: 0;\n    /* Removes any border-radius */\n    outline: none;\n    /* Removes the outline on focus */\n    box-shadow: none;\n    /* Removes any box shadow */\n    padding-left: 0;\n    /* Adjust padding to align text */\n    background-color: transparent;\n    /* Makes the background transparent */\n}\n\n.chatbotmodal input.form-control::placeholder {\n    color: #6c757d;\n    font-style: italic;\n}\n\n.chatbotmodal input.form-control:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n}\n\n.messenger-icon {\n    width: 50px;\n    height: 50px;\n    cursor: pointer;\n    font-size: 1.5rem;\n    transition: transform 0.3s ease-in-out;\n}\n\n.messenger-icon:hover {\n    transform: scale(1.1);\n}\n\n.chat-size {\n    font-size: 8px;\n}\n\n.chat-close-button{\n    font-size: 2rem !important;\n    width: 2em;\n}\n\n.notification-dot {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 12px;\n    height: 12px;\n    background-color: red;\n    border-radius: 50%;\n    border: 2px solid white; /* Optional border to make it stand out */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
